module.exports = __webpack_public_path__ + "static/img/nav_bg.6516b8d6.png";